/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */


import { getUserToken } from "../helpers/sso-helper";
import { filterUserProfileInfo } from "./../helpers/documentHelper";

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    document.getElementById("getProfileButton").onclick = run;
  }
});

export async function run() {
  
  await sendEmailDataToApi();
}

/* -------------------------
   🚀 MAIN API SEND FUNCTION
-------------------------- */
async function sendEmailDataToApi() {
  try {
    
    let token = await getUserToken();
    const item = Office.context.mailbox.item;
    const subject = item.subject || "";
    const from = item.from?.emailAddress || "";
    const to = (item.to || []).map(r => r.emailAddress).join(", ");
    const body = await getBodyAsText(item);
    const dateCreated = item.dateTimeCreated
      ? new Date(item.dateTimeCreated).toISOString()
      : "";


    // Get .eml as blob
    const fileResult = await getAsFile(item);
    const base64 = fileResult.value;
    const blob = base64ToBlob(base64, "message/rfc822");

    // Build multipart form data
    const formData = new FormData();
    formData.append("subject", subject);
    formData.append("from", from);
    formData.append("to", to);
    formData.append("body", body);
    formData.append("dateCreated", dateCreated);
    formData.append("emailFile", blob, `${subject || "email"}.eml`);
    


    // POST to your API with Bearer token
        const response = await fetch("https://localhost:44352/api/outlook/upload", {
      method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      body: formData
    });

    if (!response.ok) throw new Error("Failed to send email to API");

    console.log("✅ Email posted successfully!");
  } catch (err) {

    console.error("❌ Error posting email:", err);
  }
}

/* -------------------------
   📎 HELPER FUNCTIONS
-------------------------- */
function getAsFile(item) {
  return new Promise((resolve, reject) => {
    item.getAsFileAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result);
      } else {
        reject(result.error);
      }
    });
  });
}

function base64ToBlob(base64, mimeType) {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

function getBodyAsText(item) {
  return new Promise((resolve, reject) => {
    item.body.getAsync("text", (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(result.error);
      }
    });
  });
}
